<template>
  <div>
    <div class="my-14" v-if="detailPeriod.status === 'created'">
      <div class="subtitle-1">Biểu phí trong kỳ chưa được tổng kết.</div>
      <div v-if="$auth.policies['summary-period']" class="subtitle-1">
        Vui lòng thực hiện thao tác [Tiến hành tổng kết].
      </div>
      <v-btn
        v-if="$auth.policies['summary-period']"
        class="ml-6 mt-6"
        depressed
        dark
        color="#0D47A1"
        @click="summaryPeriod"
      >
        <v-icon>mdi-wallet-plus</v-icon> &nbsp; TIẾN HÀNH TỔNG KẾT
      </v-btn>
    </div>
    <div class="my-14" v-if="detailPeriod.status === 'running'">
      <loading-line-summary></loading-line-summary>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import LoadingLineSummary from './LoadingLineSummary.vue'
export default {
  components: {
    LoadingLineSummary
  },
  computed: {
    ...mapGetters({
      detailPeriod: 'tuitionFeePeriod/detailPeriod',
      user: 'auth/user'
    })
  },
  methods: {
    ...mapActions({
      updatePeriod: 'tuitionFeePeriod/updatePeriod'
    }),
    summaryPeriod() {
      this.$dialog.confirm({
        title: 'Xác nhận tổng kết kỳ đóng?',
        text:
          'Hệ thống sẽ thực hiện tổng kết kỳ đóng này.<br/> Thao tác này có thể sẽ mất nhiều thời gian, vui lòng đợi.',
        okText: 'Xác nhận',
        cancelText: 'Hủy',
        done: async () => {
          try {
            await this.updatePeriod({
              id: this.detailPeriod.id,
              data: { status: 'running', type: 'all', generatedBy: this.user.id }
            })
            this.$alert.success('Đã tổng kết thành công!')
          } catch (e) {
            let msg = {
              title: 'Lỗi thao tác',
              description: 'Hệ thống đang thực hiện tổng kết. Vui lòng chờ.'
            }
            if (e === 'Connection fail') {
              msg = {
                title: 'Lỗi kết nối',
                description: 'Không thể thực hiện tổng kết. Vui lòng thử lại.'
              }
            }
            this.$alert.error({ title: msg.title, description: msg.description })
          }
        }
      })
    }
  }
}
</script>
